import {Component} from 'react';

/**
 * This is a wrapper component to allow for custom colours around a specific react component.
 * The component must specify this.page in order to have enable custom highlighting. The
 * this.page value allows this component to scope the highlighting to this component only!
 */
export default class CommunityPage extends Component {
	// Must be called on mount and update due to the routing of the community page
	componentDidMount() {
		if (
			this.props.community &&
			this.props.community.profile &&
			this.props.community.profile.customColour
		) {
			document.documentElement.style.setProperty(
				'--accent-colour',
				this.props.community.profile.customColour
			);
			document.documentElement.style.setProperty('--sec-colour', '#4b4641');
		}
	}

	componentDidUpdate() {
		if (
			this.props.community &&
			this.props.community.profile &&
			this.props.community.profile.customColour
		) {
			document.documentElement.style.setProperty(
				'--accent-colour',
				this.props.community.profile.customColour
			);
			document.documentElement.style.setProperty('--sec-colour', '#4b4641');
		} else {
			// custom colour removed
			document.documentElement.style.removeProperty('--accent-colour');
			document.documentElement.style.removeProperty('--sec-colour');
		}
	}

	componentWillUnmount() {
		document.documentElement.style.removeProperty('--accent-colour');
		document.documentElement.style.removeProperty('--sec-colour');
	}
}



// WEBPACK FOOTER //
// ./src/community/CommunityPage.js